class InteractiveHotspot {
  constructor(data) {
    this.text = data.text
    this.position = data.position
  }

  get type() {
    return 'hotspot'
  }

  getHtmlOutput() {
    var html = '<div class="interactive-label ' + this.position + '"><span>'
    html += this.text
    html += '</span></div>'
    return html;
  }
}

export { InteractiveHotspot }
